export var FilespaceMigrationStatus;
(function (FilespaceMigrationStatus) {
    // migration has been created, but not started yet
    FilespaceMigrationStatus["IDLE"] = "idle";
    // preparing source & destination hubs
    FilespaceMigrationStatus["PREPARING"] = "preparing";
    // the desktop client can start the migration
    FilespaceMigrationStatus["READY_FOR_MIGRATION"] = "ready_for_migration";
    // the desktop client is migrating
    FilespaceMigrationStatus["MIGRATING"] = "migrating";
    // migration is completed, yet the source filespace needs to be decommissioned
    FilespaceMigrationStatus["MIGRATED"] = "migrated";
    // migration is cancelled
    FilespaceMigrationStatus["CANCELLED"] = "cancelled";
    // the source filespace has been decommissioned
    FilespaceMigrationStatus["DECOMMISSIONED"] = "decommissioned";
    // migration is in error state
    FilespaceMigrationStatus["ERROR"] = "error";
})(FilespaceMigrationStatus || (FilespaceMigrationStatus = {}));
export const ACTIVE_FILESPACE_MIGRATION_STATUSES = [
    FilespaceMigrationStatus.IDLE,
    FilespaceMigrationStatus.PREPARING,
    FilespaceMigrationStatus.READY_FOR_MIGRATION,
    FilespaceMigrationStatus.MIGRATING,
];
export var MigrationStatus;
(function (MigrationStatus) {
    MigrationStatus["MIGRATED"] = "MIGRATED";
    MigrationStatus["MIGRATING"] = "MIGRATING";
    MigrationStatus["BLOCKED"] = "BLOCKED";
    MigrationStatus["NOT_MIGRATED"] = "NOT_MIGRATED";
})(MigrationStatus || (MigrationStatus = {}));
export var MigrationBlocker;
(function (MigrationBlocker) {
    MigrationBlocker["NOT_INITIALIZED"] = "NOT_INITIALIZED";
    MigrationBlocker["UNSUPPORTED_TYPE"] = "UNSUPPORTED_TYPE";
    MigrationBlocker["SUSPENDED"] = "SUSPENDED";
    MigrationBlocker["SUSPENDING"] = "SUSPENDING";
    MigrationBlocker["RENAMING"] = "RENAMING";
})(MigrationBlocker || (MigrationBlocker = {}));
